import { useEffect, useRef } from 'react';
import { useInView, useReducedMotion } from 'framer-motion';

/**
 * Runs `tick` on an interval while the element is in view. Pauses when off-screen.
 */
export function useDemoAutoplay(ref, tick, intervalMs, enabled = true) {
  const reduceMotion = useReducedMotion();
  const isInView = useInView(ref, { amount: 0.3, once: false });
  const tickRef = useRef(tick);
  tickRef.current = tick;

  useEffect(() => {
    if (!enabled || !isInView) return undefined;
    const delayMs = reduceMotion ? Math.round(intervalMs * 1.22) : intervalMs;
    const id = window.setInterval(() => tickRef.current(), delayMs);
    return () => window.clearInterval(id);
  }, [enabled, isInView, intervalMs, reduceMotion]);
}
